/*
 * Created Date: Thu, 3rd Dec 2020, 12:30:15 pm
 * Author: Kristyna Fojtikova
 * Email: kristyna.fojtikova@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import React, { useState } from 'react';
import * as R from 'ramda';

import ChecklistImageViewer from './ChecklistImageViewer';
import ChecklistQuestionsViewer from './ChecklistQuestionsViewer';

//sample checklistQuestions
//  [{
//   "id": "918c66a1-8dc6-4472-8b38-3fd480fa50bd",
//   "question": "Are all the standard tower components present and in good condition?",
//   "approved": true,
//   "image": {
//       "id": "tower-type-img/3f522ddc-0d96-441f-9292-b73b55a3d332.jpeg",
//       "url": "https://pasma-dev-files.s3.eu-west-1.amazonaws.com/tower-type-img/3f522ddc-0d96-441f-9292-b73b55a3d332.jpeg?AWSAccessKeyId=ASIAX6T73A4Z7F2JWQNM&Expires=1694700892&Signature=0j3aMSaXjAJXQs8IvlvA6Mzz0FU%3D&X-Amzn-Trace-Id=Root%3D1-6503074c-06977ee06d60482b6efbe517%3BParent%3D4500da70729273b4%3BSampled%3D0%3BLineage%3D7dca54fc%3A0&x-amz-security-token=IQoJb3JpZ2luX2VjEF0aCWV1LXdlc3QtMSJHMEUCIDlDrrA0M8DKqlH65C%2BYo6z0ky3HOsnRq%2BKnExSeXsMKAiEA%2FZLa%2BaI2774sBDhOPIZpi2lT31%2FdFECTEH%2FWZQnOPWoq7gIIRhACGgw1NDY4MDI2OTgwMzUiDBDbeGnnzbOlFp07FSrLAiKc1vqM94et39F4%2BqKeBiq5qm0OLsKkZi%2BwD2AttDdxtzOmDA%2FfrkKYa0sPXdrhxEefTOlA10OmC%2BPYnCudMtXguPcsdxO6YN4HZcbmv%2BZVbq8pKL6NXfiDREdu9Lz4jL8%2F4qOd7VNynjY4fJuZC8G7SJhcMukJ%2BijKop6rzOl0kddxySV%2Fp3bSUGzfklv0%2BxXC0wUEFPCpHqp4oHW6wSsRKPWo%2BR79ZqxlQXiPscYmIUlmjaj0yT1PQzsgSj2dytrm2AU2v0zuHwwa0Bis5w2uF%2BgX9RePrgexTQ3BFtz4sNXlPcEwF8GsCVAfVnHsp0Na88u%2Bv0tW7o6IsJWQplD%2B8oDia5DcNL5MUNCB8aqzcucXXlYWM2zEtdESOoOXevH%2F0kQPsWgz4MnKOcNdVdZ4cSUeK%2Bsp9B48THMCG6IIXMMCFeBI5K86oqIwtYSMqAY6ngH3Zg%2FWr2yXCYY8kQBeZdXTReMybxfn0m1yzn%2BEQXdosronBIRw7BXW6K1IX1pgRMDcLN0dE3VCrv3oEdne2gIG0Jj5NkyvSnsUjpYjp8rh4rLbaCj0OaWsoFv9%2B5HTFUjfbtnNwxbiTPr1gSFY1cdplVE397eOKEo5T%2Bz%2B6A7P0R%2F8izwigufwJ66sKRjdayy67elObH22fY4KP2mKqg%3D%3D"
//   }
// }]

const ChecklistPage = ({ checklistQuestions = [], setChecklistQuestions, disableEdit }) => {
  // const checklistQuestions = sampleChecklistQuestions;
  const [currentIndex, setCurrentIndex] = useState(0);

  const setQuestionApproval = (approved, index) => {
    const modifiedQuestion = checklistQuestions[index];
    modifiedQuestion.approved = approved;
    const modifiedQuestions = [...checklistQuestions];
    modifiedQuestions.splice(index, 1, modifiedQuestion);
    setChecklistQuestions(modifiedQuestions);
  };

  const markQuestionAprroved = index => {
    setQuestionApproval(true, index);
  };

  const markQuestionDisaproved = index => {
    setQuestionApproval(false, index);
  };

  //   const approveChecklist = () => {
  //     // Voila
  //   };

  if (
    !checklistQuestions ||
    !Array.isArray(checklistQuestions) ||
    R.isEmpty(checklistQuestions)
  ) {
    return null;
  }

  return (
    <div
      style={{
        flexDirection: 'row',
        display: 'flex',
      }}
    >
      <ChecklistImageViewer
        questions={checklistQuestions}
        currentIndex={currentIndex}
        setCurrentIndex={setCurrentIndex}
      />
      <ChecklistQuestionsViewer
        questions={checklistQuestions}
        currentIndex={currentIndex}
        setCurrentIndex={setCurrentIndex}
        markQuestionAprroved={markQuestionAprroved}
        markQuestionDisaproved={markQuestionDisaproved}
        disableEdit={disableEdit}
        // approveChecklist={approveChecklist}
      />
    </div>
  );
};

export default ChecklistPage;
